import { FilterFieldGroup } from '@App/forms/common/filter-field-group'

export interface HasSearchFilter<K extends Record<string, any>> {
    searchFilters: Array<FilterFieldGroup<K>>
    setSearchFilters: (filter: Partial<K>) => void
}

export const isHasSearchFilter = <K extends Record<string, any>>(obj: any): obj is HasSearchFilter<K> =>
    obj && Array.isArray(obj.searchFilters) && typeof obj.setSearchFilters === 'function'
